<template>
  <login-layout :title="pwdTit">
    <div
      class="account-tel-login"
    >
      <div class="login-tab">
        <a-tabs default-active-key="1">
          <a-tab-pane
            key="1"
            :tab="mobileTabTit"
          >
            <tel-find-pwd @submitForm="subForm" />
          </a-tab-pane>
          <a-tab-pane
            key="2"
            :tab="emailTabTit"
          >
            <email-find-pwd @submitForm="subForm" />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </login-layout>
</template>
<script>
// import { fetchApi } from '@/common'
import TelFindPwd from './personInfo/TelFindPwd'
import EmailFindPwd from './personInfo/EmailFindPwd'
import LoginLayout from '@/components/pc/account/LoginLayout'
import { mapActions } from 'vuex'
export default {
  'name': 'AccoutTelLogin',
  components: {
    TelFindPwd,
    EmailFindPwd,
    LoginLayout
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  computed: {
    mobileTabTit () {
      return this.$t('message["1118"]')
    },
    emailTabTit () {
      return this.$t('message["1510"]')
    },
    pwdTit () {
      return this.$t('message["1573"]')
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['findPwd']),
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    async subForm (fields, form) {
      const chain = await this.findPwd()
      chain.params(fields)
        .onSuccess(res => {
          this.$router.push({ name: 'AccountFindPwdSuc' })
        })
        .onNetSuccess((res) => {
          if (res.data.error) {
            this.$message.warning(res.data.message || res.data.payload[0].message)
          }
        })
        .setForm(form)
        .fetch()
    }
  }
}
</script>
